// src/App.jsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import BlogDetails from './pages/BlogDetails';
import CategoryPosts from './pages/CategoryPosts';
import Page from './pages/Page'; 
import './styles.scss';
import ServiceDetailsLayout from './pages/service/ServiceDetailsLayout';
import CaseStudies from './pages/CaseStudies';
import CaseStudiesDetails from './pages/caseStudy/CaseStudiesDetails';
import Page404 from './pages/Page404'; // Ensure the path is correct
import PrivacyPolicy from './pages/PrivacyPolicy';
import Accessibility from './pages/Accessibility';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/contact-us" element={<Contact />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/accessibility" element={<Accessibility />} />
          <Route exact path="/blog/:slug" element={<BlogDetails />} />
          <Route exact path="/:slug" element={<Page />} />
          <Route exact path="/service/:slug" element={<ServiceDetailsLayout />} />
          <Route exact path="/category/:category" element={<CategoryPosts />} />
          <Route exact path="/case-study/:slug" element={<CaseStudiesDetails />} />
          <Route exact path="/blog" element={<Blog />} />
          <Route exact path="/case-studies" element={<CaseStudies />} />
          <Route path="*" element={<Page404 />} /> {/* This should catch all unmatched routes */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
